(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["joysong-brand-principles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('joysong-brand-principles')) {
    customElements.define('joysong-brand-principles', class JoysongBrandPrinciples extends HTMLElement {
      connectedCallback() {
        this.triggers = this.querySelectorAll('[data-principle-target]');
        this.scenes = this.querySelectorAll('[data-principle-scene]');
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplayInterval = Number(this.dataset.autoplayInterval) || 6000;
        this.autoplayTimer = null;
        this.parallaxEnabled = this.hasAttribute('data-joy-principles-parallax') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.parallaxStrength = Number.parseFloat(this.dataset.parallaxStrength) || 20;
        this.parallaxFrame = null;
        this.parallaxLead = this.querySelector('.joysong-principles__parallax-lead');
        this.parallaxStage = this.querySelector('.joysong-principles__parallax-stage');

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            this.setScene(trigger.dataset.principleTarget);
            this.restartAutoplay();
          });
          trigger.addEventListener('mouseenter', () => this.setScene(trigger.dataset.principleTarget));
        });

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        this.addEventListener('shopify:block:select', (event) => {
          const trigger = event.target.closest('[data-principle-target]');
          if (!trigger) return;

          this.setScene(trigger.dataset.principleTarget);
          this.stopAutoplay();
        });

        this.startAutoplay();

        if (this.parallaxEnabled && this.parallaxLead && this.parallaxStage) {
          this.onParallaxScroll = () => {
            if (this.parallaxFrame) return;

            this.parallaxFrame = window.requestAnimationFrame(() => {
              this.parallaxFrame = null;
              const rect = this.getBoundingClientRect();
              const travel = window.innerHeight + rect.height;
              const progress = Math.min(Math.max((window.innerHeight - rect.top) / travel, 0), 1);
              const offset = (0.5 - progress) * this.parallaxStrength * 2;

              this.parallaxLead.style.setProperty('--joysong-principles-lead-parallax-offset', `${(offset * 0.65).toFixed(2)}px`);
              this.parallaxStage.style.setProperty('--joysong-principles-stage-parallax-offset', `${(-offset).toFixed(2)}px`);
            });
          };

          this.onParallaxScroll();
          window.addEventListener('scroll', this.onParallaxScroll, { passive: true });
          window.addEventListener('resize', this.onParallaxScroll);
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();

        if (this.onParallaxScroll) {
          window.removeEventListener('scroll', this.onParallaxScroll);
          window.removeEventListener('resize', this.onParallaxScroll);
        }

        if (this.parallaxFrame) window.cancelAnimationFrame(this.parallaxFrame);
      }

      setScene(id) {
        this.triggers.forEach((trigger) => {
          const active = trigger.dataset.principleTarget === id;
          trigger.classList.toggle('is-active', active);
          trigger.setAttribute('aria-pressed', String(active));
        });

        this.scenes.forEach((scene) => {
          const active = scene.dataset.principleScene === id;
          scene.classList.toggle('is-active', active);
          scene.setAttribute('aria-hidden', String(!active));
        });
      }

      startAutoplay() {
        if (!this.autoplayEnabled || this.triggers.length < 2 || this.autoplayTimer) return;

        this.autoplayTimer = window.setInterval(() => this.showNextScene(), this.autoplayInterval);
      }

      stopAutoplay() {
        if (!this.autoplayTimer) return;

        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      showNextScene() {
        const activeIndex = Array.from(this.triggers).findIndex((trigger) => trigger.classList.contains('is-active'));
        const nextIndex = activeIndex === -1 ? 0 : (activeIndex + 1) % this.triggers.length;
        this.setScene(this.triggers[nextIndex].dataset.principleTarget);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
